/* geoLocate */
/*--------------------------------------------------------------------------------*/
type GeoCoords = {
    position: {
        lat: number;
        lng: number;
    };
    accuracy: number;
    heading: number;
    speed: number;
    timestamp: number;
};
/*--------------------------------------------------------------------------------*/
export const getPosition = (params: {
    accuracy: number;
    timeout: number;
}) => new Promise<GeoCoords>((resolve, reject) => {
    const timeout = params.timeout ? params.timeout : 10000; // 10 sec
    const acrLimit = params.accuracy ? params.accuracy : 10; // 10 meter
    const buff: GeoCoords[] = [];
    if (navigator.geolocation) {
        // set timeout
        const Tcount = setTimeout(() => {
            navigator.geolocation.clearWatch(watchId);
            clearTimeout(Tcount);
            // return best accuracy
            if (buff.length) {
                buff.sort((a, b) => a.accuracy - b.accuracy);
                resolve(buff[0]);
            }
            else {
                reject('position not found');
            }
        }, timeout);
        // get position
        const watchId = watchPosition((pos) => {
            const lat = pos.coords.latitude;
            const lng = pos.coords.longitude;
            const acr = pos.coords.accuracy;
            const head = pos.coords.heading ? pos.coords.heading : 0;
            const speed = pos.coords.speed ? pos.coords.speed : 0;
            const time = pos.timestamp;
            buff.push({
                position: { lat: lat, lng: lng },
                accuracy: acr,
                heading: head,
                speed: speed,
                timestamp: time,
            });
            // accuracy check
            if (acr <= acrLimit) {
                navigator.geolocation.clearWatch(watchId);
                clearTimeout(Tcount);
                resolve({
                    position: { lat: lat, lng: lng },
                    accuracy: acr,
                    heading: head,
                    speed: speed,
                    timestamp: time,
                });
            }
        }, (err) => {
            navigator.geolocation.clearWatch(watchId);
            clearTimeout(Tcount);
            reject(err);
        });
    }
    else reject('not support geolocation');
});
/*--------------------------------------------------------------------------------*/
export const watchPosition = (
    success: PositionCallback,
    error: PositionErrorCallback
) => {
    if (navigator.geolocation) {
        return navigator.geolocation.watchPosition(success, error, {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0,
        });
    }
    return 0;
};
/*--------------------------------------------------------------------------------*/
export const toAddress = async (position: { lat: number; lng: number; }) => {
    const key = 'AIzaSyDsKimgLKSw9DAz_j8Z0HDkLTmyGhxmNiU';
    const latlng = `${position.lat},${position.lng}`;
    let url = `https://maps.googleapis.com/maps/api/geocode/json`;
    url += `?latlng=${latlng}&key=${key}`;
    // fetch
    let address = '';
    await fetch(url).then(response => response.json()).then(resp => {
        const data = resp.results;
        if (data.length) address = data[0].formatted_address;
    });
    return address;
};
/*--------------------------------------------------------------------------------*/
